// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"448":"df6983123a263496","552":"1db81cdb4f2630c9"}[chunkId] + ".js";
};